module.exports = __webpack_public_path__ + "static/media/icon-white.21ebbf27.png";